import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

const TOOLTIP_KEYS = {
  holiday: 'calendar.holiday',
  closed: 'calendar.closed',
  full: 'calendar.full',
};

export default function Day({
  unavailableStatus,
  selected,
  userDay,
  day,
  nameDay,
  numberDay,
  overlap,
  click,
}) {
  const intl = useIntl();
  const name = day.format(nameDay || 'dddd').toLowerCase();
  const date = day.format(numberDay || 'D');
  const isToday = moment().isSame(day, 'day');
  const isPast = moment().isAfter(day, 'day');
  const formatedDate = moment(day).format('YYYY-MM-DD');

  const isUnavailable = unavailableStatus?.unavailable || false;
  const reason = unavailableStatus?.reason;

  const classes = classNames('content-day', {
    'disabled-holiday': reason === 'holiday',
    'disabled-closed': reason === 'closed',
    'disabled-full': reason === 'full',
    'disabled-past': reason === 'past' || (!isUnavailable && isPast),
    'selectable': selected,
    'overlap': overlap,
    'active': userDay && moment(userDay, 'YYYY-MM-DD').isSame(formatedDate)
  });
  const labelClasses = classNames('cta-day', {
    'overlap': overlap,
  });

  const tooltipKey = TOOLTIP_KEYS[reason];
  const tooltipText = tooltipKey ? intl.formatMessage({ id: tooltipKey }) : undefined;

  const ariaLabel = tooltipText
    ? `${date} - ${tooltipText}`
    : undefined;

  return (
    <button
      disabled={isUnavailable || isPast}
      onClick={() => click(day)}
      className={labelClasses}
      aria-label={ariaLabel}
    >
      <div className="name-day">
        <p className={isToday ? 'isToday' : ''}>
          <FormattedMessage id={`day.${name}`} defaultMessage={name} />
        </p>
      </div>
      <div
        className={classes}
        data-tooltip={tooltipText}
      >
        <div>{date}</div>
      </div>
    </button>
  );
}
